<template>
  <v-btn-toggle v-model="value" :class="backgroundColor" mandatory>
    <slot></slot>
  </v-btn-toggle>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'dark'
    }
  },
  data() {
    return {
      value: ''
    }
  },
  computed: {
    toggleValue: {
      get() {
        return this.value
      },
      set(val) {
        this.value = val
      }
    },
    backgroundColor() {
      return this.theme === 'dark' ? 'activeButton' : 'grey lighten-1'
    }
  },
  mounted() {
    this.toggleValue = this.modelValue
  },
  watch: {
    modelValue() {
      this.toggleValue = this.modelValue
    },
    toggleValue(newValue, oldValue) {
      if (oldValue != '') {
        this.$emit('toggleValueChange', newValue)
      }
    }
  }
}
</script>
